import { History } from 'history';
import { SagaIterator } from 'redux-saga';

import { AppState } from './reducers';

import * as xhr from './services/browserXhr';
import configureStore, { Store } from './store/configureStore';

declare const window: any;

// TODO @types: Add typing for rootSagas
export function initStore(history: History, rootSagas: (() => SagaIterator) | null, initialState: Partial<AppState> = {}): Store<AppState> {

    let store: Store<AppState>;

    const ravenClient = typeof window !== 'undefined' && window.Raven && window.Raven.isSetup() ? window.Raven : null;
    store = configureStore<AppState>(history, xhr, initialState, ravenClient);

    if (rootSagas) {
        store.injectSaga('root', rootSagas);
    }

    return store;
}
